<template>
  <div>
    <div
      class="mt-5 mb-5"
      v-if="!showRedirectionTo"
    >
      <p class="text-center">
        <strong>{{ $t("yourOrderIsRegistered") }}</strong>
        <br />
        <span v-html="$t('success')" />
      </p>
      <p class="text-center text-grey mt-1">
        {{ $t("linkToPayment") }}
        <a :href="paymentUrl">
          {{ paymentUrl }}
        </a>
      </p>
      <p class="text-center mt-5">
        {{ $t("redirectionInto") }}
        <strong class="text-success">
          {{ $tc("secondes", redirectCount, { count: redirectCount }) }}
        </strong>
      </p>
    </div>

    <!-- If I my basket is empty -->
    <div
      class="mt-5 mb-5"
      v-if="showRedirectionTo"
    >
      <p class="text-grey text-center">
        <cite>
          {{ $t('redirectionTo', { link: paymentUrl }) }}
        </cite>
      </p>
    </div>
  </div>
</template>

<script>
import {LocaleMixin} from "@/mixins/LocaleMixin";
import VueI18n from "vue-i18n";

export default {
  name: "RedirectToPaymentService",
  mixins: [LocaleMixin],
  props: {
    paymentUrl: String
  },

  data() {
    return {
      redirectCount: 6,
      showRedirectionTo: false,
      timeInterval: null
    };
  },

  mounted() {
    this.$i18n.locale = this.getLocale();
    this.successCheckout();
  },

  methods: {
    successCheckout: function() {
      let redirectTime = this.redirectCount * 1000;

      // Count second before redirection
      this.timeInterval = setInterval(() => {
        this.redirectCount -= 1;
        if (this.redirectCount === 0) {
          clearInterval(this.timeInterval);
        }
      }, 1000);

      // Wait before redirection
      setTimeout(() => {
        this.showRedirectionTo = true;
        window.location.href = this.paymentUrl;
      }, redirectTime);
    }
  },

  // Translate component
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        yourOrderIsRegistered: "Your order is registered.",
        success:
          "You will be redirected in a few seconds to the PayZen platform <strong>to finalize the payment.</strong>",
        linkToPayment:
          "If you are not automatically redirected, please follow this link:",
        secondes: "{count} second | {count} seconds",
        redirectionInto: "Redirection into:",
        redirectionTo: "Redirection to %{link} ..."
      },
      fr: {
        yourOrderIsRegistered: "Votre commande est enregistrée.",
        success:
          "Vous allez être redirigé·e dans quelques secondes vers la plateforme PayZen <strong>pour finaliser le paiement.</strong>",
        linkToPayment:
          "Si vous n'êtes pas automatiquement redirigé, merci de suivre ce lien :",
        secondes: "{count} seconde | {count} secondes",
        redirectionInto: "Redirection dans :",
        redirectionTo: "Redirection vers %{link} ..."
      }
    }
  })
}
</script>
